import React from "react";
import iconZip from "../../img/icons-ext-file/iconZip.png"

export default function FileZip() {
    return (
        <img src={iconZip} alt="" />
    );
}